import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-detail-communication-practice',
  templateUrl: './dialog-detail-communication-practice.component.html',
})
export class DialogDetailCommunicationPracticeComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data) {}
}
